import React from 'react'
import { connect } from 'react-redux'

import ContextMenu from '@/modules/base/components/context-menu/context-menu'
import ContextMenuEditItem from '@/modules/base/components/context-menu/context-menu-edit-item/context-menu-edit-item'
import ContextMenuViewItem from '@/modules/base/components/context-menu/context-menu-view-item'
import ContextMenuDeleteItem from '@/modules/base/components/context-menu/context-menu-delete-item/context-menu-delete-item'
import { hideContextMenu } from '@/redux/ducks/listContextMenu'
import { showModal } from '@/redux/ducks/modal'
import { CONNECTION_TYPE_OFFLINE } from '@/modules/client/constants'
import { navigate } from '@/modules/layout/util/useInterceptedNavigate'

class CustomerContextMenu extends React.Component {
  constructor(props) {
    super(props)

    this.onDeleteClick = this.onDeleteClick.bind(this)
    this.onEditClick = this.onEditClick.bind(this)
    this.getContextMenuItems = this.getContextMenuItems.bind(this)
    this.closeContextMenuCalled = this.closeContextMenuCalled.bind(this)
  }

  onDeleteClick() {
    const { onDeleteClick, client } = this.props
    onDeleteClick && onDeleteClick(client)
  }

  onEditClick() {
    const { client: { id } } = this.props
    navigate(`/client/${id}`)
  }

  getContextMenuItems(readOnly) {
    const contextMenuItems = []
    const { client: { connectionStatus }, deleteReadOnly } = this.props
    if (!readOnly) {
      contextMenuItems.push(<ContextMenuEditItem key='edit' onItemClick={this.onEditClick} />)
    } else {
      contextMenuItems.push(<ContextMenuViewItem key='view' onItemClick={this.onEditClick} />)
    }
    if (!deleteReadOnly && connectionStatus === CONNECTION_TYPE_OFFLINE) {
      contextMenuItems.push(<ContextMenuDeleteItem key='delete' onItemClick={this.onDeleteClick} />)
    }
    return contextMenuItems
  }

  closeContextMenuCalled() {
    const { hideContextMenu } = this.props
    hideContextMenu()
  }

  render() {
    const { rowIndex, readOnly } = this.props
    const contextMenuItems = this.getContextMenuItems(readOnly)

    const target = document.querySelector(`[data-rowindex="${rowIndex}"]`)
    return (
      <ContextMenu
        target={target}
        closeContextMenuCalled={this.closeContextMenuCalled}>
        {contextMenuItems}
      </ContextMenu>
    )
  }

}

const mapDispatchToProps = (dispatch) => {
  return {
    hideContextMenu: () => { dispatch(hideContextMenu()) },
    showModal: (modalData) => { dispatch(showModal(modalData)) },
  }
}

export default connect(null, mapDispatchToProps)(CustomerContextMenu)
